import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
            剧集分类
          </h2>
          <p className="text-sm text-foreground-500">
            探索不同类型的精彩剧集，找到你的最爱
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group relative bg-background-100 hover:bg-background-200/80 rounded-xl p-5 md:p-6 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center ${category.color} rounded-xl mb-3 md:mb-4 text-background-50 transition-transform duration-300 group-hover:scale-110`}
              >
                <i className={`${category.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-1 whitespace-nowrap">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-500 whitespace-nowrap">
                {category.count > 0
                  ? `${category.count} 部剧集`
                  : "敬请期待"}
              </p>
              <div className="absolute top-3 right-3 md:top-4 md:right-4 w-7 h-7 flex items-center justify-center rounded-full bg-background-50 text-foreground-400 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}